export class SimpleRepairsUpdatesCommentsDeleteRequest {
  commentId!: string

  constructor(commentId: string) {
    this.commentId = commentId
  }
}
